
















import { defineClassComponent, useFold } from '@/hooks'

export default defineClassComponent<{
  value: string
}>(
  {
    props: ['value'],
  },
  () =>
    class {
      fold = useFold({
        container: 'container',
        trigger: 'trigger',
        height: 240,
      })
    },
)
